import { SignalElementsService } from './../../../services/signal-elements.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'vitalColor'
})
export class VitalColorPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendColors[value];
  }

}

@Pipe({
  name: 'vitalTrendClass'
})
export class VitalTrendClassPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendClass[value];
  }

}

@Pipe({
  name: 'vitalTrendContainerClass'
})
export class VitalTrendContainerClassPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendContainerClass[value];
  }

}

@Pipe({
  name: 'vitalOpacity'
})
export class VitalOpacityPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.opacityArr[value];
  }

}

@Pipe({
  name: 'vitalTrendText'
})
export class VitalTrendTextPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendText[value];
  }

}

@Pipe({
  name: 'vitalRiskText'
})
export class VitalRiskTextPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.riskText[SignalElementsService.calcDeteriorationRiskLevel(value)];
  }
}

@Pipe({
  name: 'vitalNewsColor'
})
export class VitalNewsColorPipe implements PipeTransform {

  transform(value: string, isCpcEws = false): any {
    if (isCpcEws) {
      return SignalElementsService.trendColors[SignalElementsService.calcCpcEwsLevel(value)];
    }
    return SignalElementsService.trendColors[SignalElementsService.calcNewsLevel(value)];
  }
}

@Pipe({
  name: 'vitalCpcEwsColor'
})
export class VitalCpcEwsColorPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendColors[SignalElementsService.calcCpcEwsLevel(value)];
  }
}

@Pipe({
  name: 'vitalGDSColor'
})
export class VitalGDSColorPipe implements PipeTransform {

  transform(value: string): any {
    
    return SignalElementsService.trendColors[SignalElementsService.calcDeteriorationRiskLevel(value)];
  }
}